<div #trigger>
	<ng-content></ng-content>
</div>

<div [ngClass]="['wrapperItemsTooltip', isHover ? 'active' : '']" #wrapper>
	<ng-content select="[item]"></ng-content>
</div>
